export const UNCATEGORIZED_CATEGORY = {
  id: "uncategorized",
  displayName: "Uncategorized",
}
export const processCategoryIds = (ids) =>
  ids.map((id) => (id === "uncategorized" ? null : id))
